import React, { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Mail, ArrowRight } from "lucide-react";

export default function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message || "Subscribed!");
      setEmail("");
    } catch { toast.error("Please enter a valid email"); }
    finally { setLoading(false); }
  };
  return (
    <form onSubmit={submit} className="flex items-center bg-white/10 rounded-full p-1 max-w-md" data-testid="newsletter-form">
      <Mail className="w-4 h-4 text-white/60 ml-4" />
      <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email for exclusive deals" className="bg-transparent flex-1 px-3 py-2.5 text-sm placeholder-white/50 focus:outline-none text-white" data-testid="newsletter-email" />
      <button disabled={loading} className="btn-primary text-sm px-5 py-2.5" data-testid="newsletter-submit">
        {loading ? "..." : <ArrowRight className="w-4 h-4" />}
      </button>
    </form>
  );
}
